export enum ProcessedMediaProperties {
  Name = 'name',
  Description = 'description',
  States = 'states',
  Media = 'media',
  Author = 'author',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  MediaId = 'mediaId',
}
export enum ProcessedMediaMetaProperties {
  MediaId = 'Media-id',
  MediaVersion = 'Media-version',
}
